import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, provide } from 'vue';
import { onClickOutside, useToggle } from '@vueuse/core';

interface Props {
  value?: string | number | null;
  label?: string | null;
  options?: any[];
  customOptions?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: string | null;
  itemId?: string;
  itemText?: string;
  icon?: string;
  inputFitWidth?: boolean;
}

interface Emits {
  (e: 'input', data: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSelect',
  props: {
    value: { default: null },
    label: { default: null },
    options: { default: () => [] },
    customOptions: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { default: undefined },
    error: { default: null },
    itemId: { default: 'id' },
    itemText: { default: 'text' },
    icon: { default: '' },
    inputFitWidth: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number | null, label: string | null, options: any[], customOptions: boolean, disabled: boolean, placeholder: string, error: string | null, itemId: string, itemText: string, icon: string, inputFitWidth: boolean };





const target = ref(null);
const isMenuOpen = ref(false);

const toggleMenu = useToggle(isMenuOpen);

const activeOption = computed(() =>
  props.options.find((option) => option[props.itemId] === props.value),
);

const valueLocal = computed({
  get() {
    return activeOption.value ? activeOption.value[props.itemText] : '';
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const selectOption = (option: any) => {
  valueLocal.value = option[props.itemId];
  toggleMenu(false);
};

onClickOutside(target, () => {
  toggleMenu(false);
});

provide('selectData', {
  valueLocal,
  selectOption,
  itemId: props.itemId,
  itemText: props.itemText,
});

return { __sfc: true,props, emit, target, isMenuOpen, toggleMenu, activeOption, valueLocal, selectOption }
}

})